import { jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { DirectionEnum } from "@perxis-auto/shared";
import Button from "../Button/Button.js";
import Icon from "../Icon/Icon.js";
import Typography from "../Typography/Typography.js";
import classnames from "../../utils/classnames.js";
import "antd/es/config-provider";
import "style-inject";
import { useProviderContext } from "../Provider/context.js";
import './DealerInfo.css';/* empty css                */
const DealerInfoHeader = ({ label, className, onClick }) => {
  const { direction } = useProviderContext();
  const isRTL = direction === DirectionEnum.Rtl;
  const directionalIcon = useMemo(
    () => /* @__PURE__ */ jsx(Icon, { name: isRTL ? "forward" : "back", className: classnames("perxis-auto-dealer-info-header__icon") }),
    [isRTL]
  );
  return /* @__PURE__ */ jsx("div", { className: classnames("perxis-auto-dealer-info-header", className), children: /* @__PURE__ */ jsx(
    Button,
    {
      type: "text",
      icon: directionalIcon,
      iconPosition: isRTL ? "right" : "left",
      iconGapSize: "normal",
      onClick,
      children: /* @__PURE__ */ jsx(Typography.Text, { level: "small", color: "darkest", className: classnames("perxis-auto-dealer-info-header__label"), children: label })
    }
  ) });
};
export {
  DealerInfoHeader,
  DealerInfoHeader as default
};
//# sourceMappingURL=DealerInfoHeader.js.map
